import { createChunk } from '../Chunks';
import { joinPaths, createURLDescriptor } from '../URLTools';
import { createChunksMatcher } from '../createChunksMatcher';
export function redirect(maybeResolvableTo, _a) {
    var _b = (_a === void 0 ? {} : _a).exact, exact = _b === void 0 ? true : _b;
    return createChunksMatcher(maybeResolvableTo, undefined, function (to, request) {
        var toHref;
        if (typeof to === 'string') {
            toHref = to[0] === '/' ? to : joinPaths('/', request.mountpath, to);
        }
        else if (to) {
            toHref = createURLDescriptor(to).href;
        }
        return toHref ? [createChunk('redirect', request, { to: toHref })] : [];
    }, exact, true // proccess during crawl
    );
}
//# sourceMappingURL=redirect.js.map